import Logo from "@/components/Logo";
import { scrollToId } from "@/lib/lenis";

const LINKS = [
  { label: "The Problem", id: "#problem" },
  { label: "Services", id: "#services" },
  { label: "The Advantage", id: "#advantage" },
  { label: "About Thom", id: "#about" },
  { label: "FAQ", id: "#faq" },
  { label: "Contact", id: "#contact" },
];

export default function Footer() {
  const go = (id) => (e) => {
    e.preventDefault();
    scrollToId(id);
  };

  return (
    <footer data-testid="main-footer" className="relative overflow-hidden border-t border-[#E2E8F0] bg-[#0F141A]">
      <div className="mx-auto max-w-[1440px] px-6 pb-10 pt-16 lg:px-12">
        <div className="flex flex-col justify-between gap-10 text-white md:flex-row md:items-start">
          <div>
            <Logo variant="light" />
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-[#94A3B8]">
              Engineering the handoff between automated systems and empowered people.
            </p>
          </div>
          <nav className="flex flex-col gap-3">
            {LINKS.map((l) => (
              <a
                key={l.id}
                href={l.id}
                onClick={go(l.id)}
                className="text-left text-sm text-[#94A3B8] transition-colors duration-200 hover:text-white"
              >
                {l.label}
              </a>
            ))}
          </nav>
          <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#626D7D]">
            <p>Engineered Handoffs</p>
            <p className="mt-2 text-[#EB5E28]">System v2.0</p>
          </div>
        </div>

        <div
          aria-hidden="true"
          className="text-outline pointer-events-none mt-14 select-none whitespace-nowrap font-display text-[13.5vw] font-semibold leading-none tracking-tight"
        >
          THOM KRINER
        </div>

        <div
          data-testid="footer-copyright-text"
          className="mt-10 flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-6 font-mono text-[10px] uppercase tracking-[0.25em] text-[#626D7D] sm:flex-row sm:items-center"
        >
          <p>© {new Date().getFullYear()} Thom Kriner LLC. All rights reserved.</p>
          <p>AI handles the rule · Humans handle the exception</p>
        </div>
      </div>
    </footer>
  );
}
